import * as Redux from 'redux';
import { HashMap } from '../constants';
import { SimManagementError } from '../models/Errors';
import { CommandTypesPayload } from '../models/state/commandTypeState';
import {
  ENSURE_COMMAND_DEFINITIONS,
  LOAD_COMMAND_DEFINITIONS,
  LOAD_COMMAND_DEFINITIONS_FAILURE,
  LOAD_COMMAND_DEFINITIONS_PENDING,
  LOAD_COMMAND_DEFINITIONS_SUCCESS,
} from './actionTypes';
import { Action, ActionMeta } from './commonActions';

/**
 * Action which loads the command defintisions from the server if required.
 * @param commandType The command type alias.
 */
export function ensureCommandDefinitions(commandType: string): Action<string> {
  return {
    type: ENSURE_COMMAND_DEFINITIONS,
    payload: commandType,
  };
}

/**
 * Action which loads the command definitions from the server.
 * @param commandType The command type alias.
 */
export function loadCommandDefinitions(commandType: string): Action<string> {
  return {
    type: LOAD_COMMAND_DEFINITIONS,
    payload: commandType,
  };
}

/**
 * Action which sets the load status of the command definitions to pending.
 * @param commandType The command type alias.
 */
export function loadCommandDefinitionsPending(commandType: string): Action<string> {
  return {
    type: LOAD_COMMAND_DEFINITIONS_PENDING,
    payload: commandType,
  };
}

/**
 * Action which handles when the command definitions are successfully loaded.
 * @param commandTypes The command definitions payload
 */
export function loadCommandDefinitionsSuccess(
  payload: CommandTypesPayload,
  commandType: string,
): ActionMeta<CommandTypesPayload, string> {
  return {
    type: LOAD_COMMAND_DEFINITIONS_SUCCESS,
    payload,
    meta: commandType,
  };
}

/**
 * Action which handles when there is a failure to load the command definitions.
 * @param error The error.
 */
export function loadCommandDefinitionsFailure(
  error: SimManagementError,
  commandType: string,
): ActionMeta<SimManagementError, string> {
  return {
    error: true,
    type: LOAD_COMMAND_DEFINITIONS_FAILURE,
    payload: error,
    meta: commandType,
  };
}
